import React from 'react';
import config from '../config';
import PlanPage from './PlanPage';
import './Societies.css';

function Societies() {
  return (
    <>
      <PlanPage
        title="Society & Community Plans"
        subtitle="Healthy living for your family and community — delivered to your doorstep."
        message="Bring the gift of health to your family and neighbours with FALSUTRA's Society Plans. Fresh fruit bowls delivered daily to your residential society."
        plans={config.societyPlans}
      />

      <div className="societies-note">
        <p className="societies-note__line">Note : The sunday four family pack.</p>
        <p className="societies-note__line">4 bowls = Parents + 2 Children.</p>
        <p className="societies-note__highlight">Just for ₹299</p>
      </div>
    </>
  );
}

export default Societies;
